<template>
	<type-wrapper class="success" regular>
		<type-grid row="13" margin>
			<type-image mode="widthFix" :src="image"></type-image>
		</type-grid>
		<type-grid row="23" margin v-if="orderList.length">
			<type-grid row="11" margin>
				<type-text type="title" size="9">支付成功</type-text>
				<type-text type="content" size="6" align="center">订单已确认</type-text>
			</type-grid>
			<type-grid row="11" margin v-if="orderList.length">
				<div id="order-html">
					<div class="single-order" v-for="(item, index) in orderList" :key="index">
						<h6>订单 {{index + 1}}</h6>
						<p>订单号: {{item.order_unique_id}}</p>
						<p>商品名称: {{item.product_name}}</p>
						<p>商品信息: {{item.product_description}}</p>
						<p>商品数量: {{item.quantity}}</p>
						<p>商品单价: {{item.final_price}}</p>
						<p>买家姓名: {{item.receiver_name}}</p>
					</div>
				</div>
			</type-grid>
			<type-grid row="11" margin v-if="orderList.length">
				<type-button whitebackdrop v-print="'#order-html'" border>打印订单</type-button>
			</type-grid>
		</type-grid>
		<type-grid row="23" margin v-else>
            <type-grid row="11" margin>
				<type-text type="title" size="9">暂无订单信息</type-text>
            </type-grid>
		</type-grid>
	</type-wrapper>
</template>

<script>
	export default {
		name: 'success',
		data() {
			return {
				orderList: [
					// {
					// 	order_unique_id: 1,
					// 	product_name: 'xaxasdasdas',
					// 	product_description: 'xaxasdasdas',
					// 	quantity: 'xaxasdasdas',
					// 	final_price: 'xaxasdasdas',
					// 	receiver_name: 'xaxasdasdas'
					// }
				],
				image: require('../../assets/image/about-img.jpg')
			}
		},
		created() {
            this.getData();
		},
		methods: {
			async getData() {
				// ?session_id=cs_test_Q0PTaYLsGdJOxiv9PyJhXkht1p94ngiXju4yezB4nRgqWa0EtDHquEdY
                console.log(JSON.parse(JSON.stringify(this.$route.query)))
				if (this.$route.query.session_id) {
					const req = {
						stripe_session_id: this.$route.query.session_id
					};
					this.$http.order.lists(req).then(res => {
						console.log(JSON.parse(JSON.stringify(res)))
						if (res.status === 'success') {
							if (res.data.list.length) {
							    this.orderList = res.data.list;
							} else {
							    this.$message('暂无订单信息');
							}
						}
					});
				} else {
					this.$message('参数错误');
				}
			}
		}
	}
</script>

<style scoped lang="less">
	.success{
		display: flex;
		flex-wrap: wrap;
        .single-order h6{
        	padding: 10px 0 5px;
        	font-weight: normal;
        }
        .single-order p{
        	color: #979797;
        	font-size: 13.5px;
        	line-height: 25px;
        	padding-bottom: 5px;
        }
	}
</style>
